import Axios from 'axios';

const UtilService = require('./util.service');
//const url = UtilService.getApiUri('CurrentlyWorkingTeacher');
const options = UtilService.getHeaderOptions();

export function getAllData(routeUrl) {
    const url = UtilService.getApiUri(routeUrl);
    return Axios.get(url, options).then(res => {
        return res.data
    }).catch(error => {
        return error.response.data
    });
}

export function getAllDataByLimit(startFrom, routeUrl) {
    const url = UtilService.getApiUri(routeUrl);
    let updateUrl = `${url}/${startFrom}`;
    console.log('updateUrl = ', updateUrl);
    return Axios.get(updateUrl, options).then(res => {
        return res.data
    }).catch(error => {
        return error.response.data
    });
}

export function getAllDataById(id, routeUrl) {
    const url = UtilService.getApiUri(routeUrl);
    let updateUrl = `${url}/${id}`;
    return Axios.get(updateUrl, options).then(res => {
        return res.data
    }).catch(error => {
        return error.response.data
    });
}

export function dataByMulParameters(mulParam, routeUrl) {
    let options2 = {
        params: mulParam,
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('accessToken')
        }
    };
    const url = UtilService.getApiUri(routeUrl);
    return Axios.get(url, options2).then(res => {
        return res.data
    }).catch(error => {
        return error.response.data
    });
}

export function getAllDataBySearchString(searchString, routeUrl) {
    const url = UtilService.getApiUri(routeUrl);
    let updateUrl = `${url}/${searchString}`;
    return Axios.get(updateUrl, options).then(res => {
        return res.data
    }).catch(error => {
        return error.response.data
    });
}

export function searchData(searchString, routeUrl) {
    const url = UtilService.getApiUri(routeUrl);
    return Axios.post(url, searchString, options).then(res => {
        return res.data;
    })
        .catch(error => {
            return error.response.data
        });
}

export function insertFormData(formData, routeUrl) {
    //console.log('formData', formData);
    const url = UtilService.getApiUri(routeUrl);
    return Axios.post(url, formData, options).then(res => {
        return res.data;
    })
        .catch(error => {
            return error.response.data
        });
}

export function updateFormData(formData, routeUrl) {
    //console.log('formData --- formData', formData);
    const url = UtilService.getApiUri(routeUrl);
    let updateUrl = `${url}/${formData.id}`;
    return Axios.patch(updateUrl, formData, options).then(res => {
        return res.data
    }).catch(error => {
        return error.response.data
    })
}

export function getDataByInspectionId(inspectionId, routeUrl) {
    const url = UtilService.getApiUri(routeUrl);
    let getUrl = `${url}/${inspectionId}`;
    return Axios.get(getUrl, options).then(res => {
        return res.data
    }).catch(error => {
        return error.response.data
    })
}

export function getInstituteDataByid(value, columnName, routeUrl) {
    const url = UtilService.getApiUri('get-instute-list');
    let getUrl = `${url}/${value}/${columnName}`;
    return Axios.get(getUrl, options).then(res => {
        return res.data
    }).catch(error => {
        return error.response.data
    })
}

export function deleteRow(rowId, routeUrl) {
    const url = UtilService.getApiUri(routeUrl);
    const deleteUrl = `${url}/${rowId}`;
    return Axios.delete(deleteUrl, options).then(res => {
        return res.data;
    }).catch(error => {
        return error.response.data;
    });
}

export function uploadAttachFile(inspectionId, routeUrl, formData) {
    const url = UtilService.getApiUri(routeUrl);
    let getUrl = `${url}/${inspectionId}`;
    return Axios.post(getUrl, formData, options).then(res => {
        return res.data
    }).catch(error => {
        return error.response.data
    })
}

export function uploadDocFile(routeUrl, formData) {
    const url = UtilService.getApiUri(routeUrl);
    return Axios.post(url, formData, options).then(res => {
        return res.data
    }).catch(error => {
        return error.response.data
    })
}

export function getServerSideData(query_Data, routeUrl) {
    let options2 = {
        params: query_Data,
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('accessToken')
        }
    };
    const url = UtilService.getApiUri(routeUrl);
    return Axios.get(url, options2).then(res => {
        return res.data
    }).catch(error => {
        return error.response.data
    });
}

export function getAllDataByTable(t_name, routeUrl) {
    const url = UtilService.getApiUri(routeUrl);
    let updateUrl = `${url}/${t_name}`;
    return Axios.get(updateUrl, options).then(res => {
        return res.data
    }).catch(error => {
        return error.response.data
    });
}


// WEBPACK FOOTER //
// ./src/services/common.service.js